import cloneDeep from 'lodash/cloneDeep';
import baseDefaults from '../Base/Base.defaults';
import baseButtonDefaults from '../BaseButton/BaseButton.defaults';

export default {
  ...cloneDeep(baseDefaults),
  height: {
    desktop: 500,
  },
  button: cloneDeep(baseButtonDefaults),
};
